const MIN_WINDOW = 0.1;

/** Where a newly inserted layer sits on the output clip timeline:
 *  playhead → playhead + media duration, clamped to the clip, never
 *  shorter than MIN_WINDOW ("media dictates length" — no loop, no trim). */
export function computeLayerWindow(
  { playhead, duration, clipDuration }: { playhead: number; duration: number; clipDuration: number },
): { start: number; end: number } {
  const clip = Math.max(clipDuration, MIN_WINDOW);
  let start = Math.min(Math.max(playhead, 0), clip);
  let end = Math.min(start + Math.max(duration, MIN_WINDOW), clip);
  if (end - start < MIN_WINDOW) {
    end = Math.min(clip, start + MIN_WINDOW);
    start = Math.max(0, end - MIN_WINDOW);
  }
  return { start, end };
}
